import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export interface LoaderProps {
	title?: string;
	timeout?: number;
	link?: string;
	circle?: boolean;
}

export function Loader({ title, timeout, link, circle }: LoaderProps) {
	const navigate = useNavigate();

	useEffect(() => {
		let handleTimeout: NodeJS.Timeout;
		if (timeout && link)
			handleTimeout = setTimeout(() => {
				navigate({ to: link });
			}, timeout);

		return () => {
			clearTimeout(handleTimeout);
		};
	}, [link, navigate, timeout]);
	return (
		<div className="h-screen w-full bg-light text-center">
			<div className="absolute top-[40%] left-1/2 -translate-x-1/2 w-full">
				{circle && <span className="circle-loader"></span>}
				{title && (
					<p
						className="heading-1 text-grey my-6 inset-x-auto"
						dangerouslySetInnerHTML={{
							__html: title,
						}}
					/>
				)}
				{!circle && (
					<div className="flex justify-center items-center">
						<div className="flex space-x-2">
							<div className="w-4 h-4 bg-grey rounded-full animate-bounce1"></div>
							<div className="w-4 h-4 bg-grey rounded-full animate-bounce2"></div>
							<div className="w-4 h-4 bg-grey rounded-full animate-bounce3"></div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default Loader;
